<div
    class="cp-selector-container"
    [formGroup]="form"
    [hidden]="isHidden"
    (clickOutside)="onClickOutside()"
    (click)="onClickInside($event)"
>
    <se-floating-label
        [class.invisible]="!control.isWithLabel"
        [for]="control.id"
        [state]="formControl?.invalid ? 'error' : isDisabled ? 'disabled' : 'active'"
        [tooltip]="control.name"
    >
        {{ control.name }}
    </se-floating-label>

    <se-selector-web
        #cpSelector
        class="cp-selector"
        [(filter)]="filterText"
        [(status)]="status"
        [isInError]="formControl?.invalid ?? false"
        [id]="control.id"
        [emitItemsById]="false"
        [itemList]="dataSource"
        [formControlName]="control.id"
        [style.height.px]="control.getHeight()"
        [title]="!control.isWithLabel ? control.name : ('MultiSelected' | translate)"
        [visibleSelectAllButton]="true"
        (maxSelectableItemsNotify)="onMaxSelectableItems($event)"
    >
        <ng-container extra-buttons-before>
            <cp-additional-content
                *ngFor="let additionalContent of control.additionalContent"
                [control]="additionalContent"
                [cardId]="cardId"
                [disabled]="isDisabled"
            ></cp-additional-content>
        </ng-container>
    </se-selector-web>
</div>
